export default {
      id: "xing-24-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/iconset.svg#xing-24",
      toString: function () {
        return this.url;
      }
    }